import { DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin } from "/home/web/wap/releases/20261104-173053-e2d42a89/vue_src/nuxt/node_modules/.pnpm/@unhead+vue@2.1.17_vue@3.5.44_typescript@5.4.5_/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  disableCapoSorting: false,
  plugins: [DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin],
}